import React, { useEffect, useState } from 'react';
const PURCHASES = [{
  name: 'María L.',
  province: 'Buenos Aires',
  product: 'Kit Reiki Pro'
}, {
  name: 'Carolina S.',
  province: 'Córdoba',
  product: 'Sistema Maestría Reiki'
}, {
  name: 'Valentina R.',
  province: 'Santa Fe',
  product: 'Kit Reiki Pro'
}, {
  name: 'Luciana M.',
  province: 'Mendoza',
  product: 'Sistema Maestría Reiki'
}, {
  name: 'Florencia G.',
  province: 'Tucumán',
  product: 'Kit Reiki Pro'
}, {
  name: 'Romina P.',
  province: 'Entre Ríos',
  product: 'Sistema Maestría Reiki'
}, {
  name: 'Agustina D.',
  province: 'Salta',
  product: 'Kit Reiki Pro'
}, {
  name: 'Camila T.',
  province: 'Neuquén',
  product: 'Sistema Maestría Reiki'
}, {
  name: 'Daniela F.',
  province: 'Misiones',
  product: 'Kit Reiki Pro'
}, {
  name: 'Sofía B.',
  province: 'Chaco',
  product: 'Sistema Maestría Reiki'
}, {
  name: 'Paula V.',
  province: 'San Juan',
  product: 'Kit Reiki Pro'
}, {
  name: 'Andrea K.',
  province: 'Río Negro',
  product: 'Sistema Maestría Reiki'
}, {
  name: 'Julieta H.',
  province: 'Corrientes',
  product: 'Kit Reiki Pro'
}, {
  name: 'Natalia C.',
  province: 'Jujuy',
  product: 'Sistema Maestría Reiki'
}, {
  name: 'Gabriela R.',
  province: 'La Pampa',
  product: 'Kit Reiki Pro'
}];
function getRandomMinutes() {
  return Math.floor(Math.random() * 25) + 3;
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [minutes, setMinutes] = useState(getRandomMinutes());
  useEffect(() => {
    // Show first popup after 8 seconds
    const initialDelay = setTimeout(() => {
      setVisible(true);
    }, 8000);
    return () => clearTimeout(initialDelay);
  }, []);
  useEffect(() => {
    if (!visible) return;
    // Hide after 5 seconds
    const hideTimer = setTimeout(() => {
      setVisible(false);
      // Show next one after 12-20 seconds
      const nextDelay = Math.floor(Math.random() * 8000) + 12000;
      const showTimer = setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % PURCHASES.length);
        setMinutes(getRandomMinutes());
        setVisible(true);
      }, nextDelay);
      return () => clearTimeout(showTimer);
    }, 5000);
    return () => clearTimeout(hideTimer);
  }, [visible, currentIndex]);
  const purchase = PURCHASES[currentIndex];
  return <div className={`fixed bottom-20 md:bottom-4 left-4 z-[55] max-w-[280px] sm:max-w-xs transition-all duration-500 ease-out ${visible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0 pointer-events-none'}`} data-id="element-397">
      <div className="bg-[#111111] border border-white/10 rounded-xl p-3.5 shadow-[0_8px_30px_rgba(0,0,0,0.5)] backdrop-blur-sm" data-id="element-398">
        <div className="flex items-start gap-3" data-id="element-399">
          <div className="w-9 h-9 rounded-full bg-[#eab308]/20 border border-[#eab308]/30 flex items-center justify-center flex-shrink-0" data-id="element-400">
            <span className="text-sm" data-id="element-401">✨</span>
          </div>
          <div className="min-w-0" data-id="element-402">
            <p className="text-white text-sm font-semibold leading-tight" data-id="element-403">
              {purchase.name}
              <span className="text-gray-400 font-normal" data-id="element-404"> de </span>
              <span className="text-[#eab308]" data-id="element-405">{purchase.province}</span>
            </p>
            <p className="text-gray-400 text-xs mt-0.5" data-id="element-406">
              adquirió{' '}
              <span className="text-gray-200 font-medium" data-id="element-407">
                {purchase.product}
              </span>
            </p>
            <p className="text-gray-500 text-[10px] mt-1" data-id="element-408">
              hace {minutes} minutos
            </p>
          </div>
        </div>
      </div>
    </div>;
}